// extracted by mini-css-extract-plugin
export default {"root":"PasswordModal_root__6ZX4B"};